import { useState } from "react";
import { SocialIcon } from "react-social-icons";

import { Button, ExternalLink, Input, InternalLink, Line, P } from "@sorcery/ui";

import { Logo } from "~/components/atoms/Logo";
import {
  aboutPath,
  allCardsPath,
  alphaPath,
  artPath,
  arthurianPath,
  becomeARetailerPath,
  betaPath,
  careersPath,
  contactPath,
  curiosaPath,
  discordGroupPath,
  dragonlordPath,
  fbGroupPath,
  formatsPath,
  homePath,
  howToPlayPath,
  locatorPath,
  newsItemPath,
  newsPath,
  organizedPlayPath,
  playNetworkPath,
  privacyPath,
  shopPath,
  termsPath,
} from "~/utils/paths";

const FooterLinks = () => (
  <>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 font-semibold uppercase text-big-text-color underline underline-offset-4">
        Sorcery
      </h4>
      <ul className="font-medium text-gray-400">
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={newsPath}
        >
          <li className="mb-1">News</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={shopPath}
          target="_blank"
        >
          <li className="mb-1">Shop</li>
        </ExternalLink>

        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={artPath}
        >
          <li className="mb-1">Art</li>
        </InternalLink>

        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={howToPlayPath}
        >
          <li className="mb-1">How to Play</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={formatsPath}
        >
          <li className="mb-1">Formats</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={organizedPlayPath}
        >
          <li className="mb-1">Organized Play</li>
        </InternalLink>
      </ul>
    </div>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 font-semibold uppercase text-big-text-color underline underline-offset-4">
        Product
      </h4>
      <ul className="font-medium text-gray-400">
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={dragonlordPath}
        >
          <li className="mb-1">Dragonlord</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={arthurianPath}
        >
          <li className="mb-1">Arthurian Legends</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={betaPath}
        >
          <li className="mb-1">Beta Edition</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={alphaPath}
        >
          <li className="mb-1">Alpha Edition</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={becomeARetailerPath}
        >
          <li className="mb-1">Become a Retailer</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={
            "https://www.tcgplayer.com/search/sorcery-contested-realm/product?productLineName=sorcery-contested-realm&view=grid"
          }
          target="_blank"
        >
          <li className="mb-1">Shop on TCGPlayer</li>
        </ExternalLink>
      </ul>
    </div>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 font-semibold uppercase text-big-text-color underline underline-offset-4">
        Resources
      </h4>
      <ul className="font-medium text-gray-400">
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={allCardsPath}
          target="_blank"
        >
          <li className="mb-1">Card Library</li>
        </ExternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={curiosaPath}
          target="_blank"
        >
          <li className="mb-1">Deckbuilder</li>
        </ExternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={locatorPath}
        >
          <li className="mb-1">Store Locator</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={playNetworkPath}
          target="_blank"
        >
          <li className="mb-1">Play Network</li>
        </ExternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={newsItemPath("dust-in-sorcery-contested-realm")}
        >
          <li className="mb-1">The Dust System</li>
        </InternalLink>
      </ul>
    </div>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 font-semibold uppercase text-big-text-color underline underline-offset-4">
        Company
      </h4>
      <ul className="font-medium text-gray-400">
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={aboutPath}
        >
          <li className="mb-1">About</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={contactPath}
        >
          <li className="mb-1">Contact</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={discordGroupPath}
          target="_blank"
        >
          <li className="mb-1">Discord</li>
        </ExternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={fbGroupPath}
          target="_blank"
        >
          <li className="mb-1">Community</li>
        </ExternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={careersPath}
        >
          <li className="mb-1">Careers</li>
        </InternalLink>

        {/* <li className="mb-1">
                <InternalLink className="hover:text-white transition-colors duration-150 ease-in-out" href={}>Terms</InternalLink>
              </li> */}
        <li className="mb-1">
          <InternalLink
            className="transition-colors duration-150 ease-in-out hover:text-white"
            href={privacyPath}
          >
            Privacy
          </InternalLink>
        </li>
        <li className="mb-1">
          <InternalLink
            className="transition-colors duration-150 ease-in-out hover:text-white"
            href={termsPath}
          >
            T&C's
          </InternalLink>
        </li>
      </ul>
    </div>
  </>
);

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [emailMissingError, setEmailMissingError] = useState(false);

  const submitEmail = () => {
    setEmailMissingError(false);

    if (
      !email?.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
    ) {
      return setEmailMissingError(true);
    }

    const address = `https://sorcerytcg.us14.list-manage.com/subscribe/post?u=9f6561c50bcf1d37bf7cf57d3&amp;id=ad3d822eaa&amp;f_id=003e93e0f0&EMAIL=${encodeURIComponent(
      email,
    )}`;

    // biome-ignore lint/style/noRestrictedGlobals: <explanation>
    window.open(address);
    setEmail("");
  };

  return (
    <footer className="bg-background pb-4 text-xs">
      <div className="sorcery-wide-container mx-auto h-full w-full p-8">
        {/* <Line className="mt-12" /> */}
        <div className="my-8 mb-6 flex flex-col items-center justify-between lg:flex-row lg:items-start">
          <div className="mb-8 flex flex-col items-center lg:mb-0 lg:items-start">
            <div className="w-[14rem] cursor-pointer lg:-ml-3 lg:w-[16rem]">
              <InternalLink href={homePath}>
                <Logo />
              </InternalLink>
            </div>

            <P className="!mb-0 text-gray-400">
              <span>© 2024 by Erik's Curiosa Limited.</span>
              <span className="lg:hidden"> All Rights Reserved.</span>
            </P>
            <P className="hidden text-gray-400 lg:inline">All Rights Reserved.</P>
          </div>

          <div className="grid grid-cols-2 gap-4 xs:grid-cols-4 md:gap-6 lg:gap-8 xl:gap-10">
            <FooterLinks />
          </div>
        </div>

        <div>
          <Line className="mb-8" />
        </div>

        <div className="flex flex-col items-center justify-center lg:items-start">
          <div className="flex gap-1">
            <Input
              type="email"
              className="!mb-0 max-w-xs sm:min-w-[240px]"
              placeholder="Subscribe to get updates..."
              onChange={(v) => v && setEmail(v)}
              error={emailMissingError}
            />
            <Button variant={"secondary"} className="mr-4 !h-[33px]" onClick={() => submitEmail()}>
              Confirm
            </Button>
          </div>
          <div>
            <SocialIcon
              url="https://discord.gg/mWFU7WK5rm"
              bgColor="transparent"
              fgColor="#E3DDD3"
            />
            <SocialIcon
              url="https://www.youtube.com/channel/UCqmv-SKT0_SO5FbP3vGZ_uQ/videos"
              bgColor="transparent"
              fgColor="#E3DDD3"
            />
            <SocialIcon url="https://x.com/SorceryTCG" bgColor="transparent" fgColor="#E3DDD3" />
            <SocialIcon
              url="https://www.facebook.com/SorceryTCG"
              bgColor="transparent"
              fgColor="#E3DDD3"
            />
            <SocialIcon
              url="https://www.instagram.com/sorcerytcg/"
              bgColor="transparent"
              fgColor="#E3DDD3"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
